import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { GraduationCap, Home, Plus, LogOut, User } from 'lucide-react';

function Navbar() {
  const { usuario, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/auth');
  };

  return (
    <nav className="bg-gradient-to-r from-slate-950 to-slate-900 border-b border-slate-800/50 backdrop-blur-xl sticky top-0 z-50">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo/Brand */}
          <Link 
            to="/" 
            className="flex items-center gap-3 text-white hover:text-red-400 transition-colors group"
          >
            <div className="w-8 h-8 bg-gradient-to-r from-red-600 to-orange-500 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform">
              <GraduationCap className="w-5 h-5 text-white" />
            </div>
            <span className="text-xl font-bold bg-gradient-to-r from-white to-slate-300 bg-clip-text text-transparent">
              Cursos Online
            </span>
          </Link>
          
          {/* Navigation Links */}
          <div className="hidden md:flex items-center gap-6">
            <Link 
              to="/" 
              className="flex items-center gap-2 text-slate-300 hover:text-white transition-colors"
            >
              <Home className="w-4 h-4" />
              <span>Início</span>
            </Link>
            
            {usuario?.nivel === 'admin' && (
              <Link 
                to="/criar-curso" 
                className="flex items-center gap-2 text-slate-300 hover:text-white transition-colors"
              >
                <Plus className="w-4 h-4" />
                <span>Criar Curso</span>
              </Link>
            )}
          </div>

          {/* User Info & Actions */}
          <div className="flex items-center gap-4">
            {usuario && (
              <div className="hidden sm:flex items-center gap-3">
                <div className="flex items-center gap-2 text-slate-300">
                  <div className="w-8 h-8 bg-slate-700 rounded-full flex items-center justify-center">
                    <User className="w-4 h-4" />
                  </div>
                  <span className="text-sm font-medium">
                    {usuario.nome || usuario.email}
                  </span>
                  {usuario.nivel === 'admin' && (
                    <span className="px-2 py-1 bg-red-600/20 text-red-400 border border-red-600/30 rounded-full text-xs font-semibold">
                      Admin
                    </span>
                  )}
                </div>
              </div>
            )}
            
            <Button
              onClick={handleLogout}
              variant="outline"
              size="sm"
              className="border-slate-600 text-slate-300 hover:bg-red-600/20 hover:text-red-400 hover:border-red-600/50"
            >
              <LogOut className="w-4 h-4 mr-2" />
              <span className="hidden sm:inline">Sair</span>
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar; 